import { render } from "./SetUnNftOwners.vue?vue&type=template&id=50205364&scoped=true"
import script from "./SetUnNftOwners.vue?vue&type=script&lang=js"
export * from "./SetUnNftOwners.vue?vue&type=script&lang=js"

import "./SetUnNftOwners.vue?vue&type=style&index=0&id=50205364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50205364"]])

export default __exports__